import DomainTopic from "./DomainTopic";

const SubjectTopic = () => {
  return (
    <section className=" w-full mx-auto lg:h-[600px] ">
      <div>
        <div className="text-7xl md:text-17xl w-full flex flex-col items-center justify-center">
        <div className=" flex flex-col items-center justify-around">
            <h1 className="text-[#FF820F] m-0 text-center tracking-[0.01em] text-7xl md:text-13xl font-bold z-10 ">
              Challenge Yourself
            </h1>
            <h3 className="md:text-center text-5xl rounded-lg  max-md:mx-3 max-md:px-1   text-center font-bold max-sm:bg-black  md:text-13xl z-10 mt-2 text-white"><span className="sm:bg-black sm:px-6  rounded-lg py-1"> ATTEMPT FREE MOCK TESTS</span></h3>
          </div>
        </div>
        <div className="relative md:top-[-50px] top-[-40px]">
          <div className="md:h-[520px] h-[1000px]  w-[50%]  rounded-xl mb-2 mx-[!important] absolute  left-0 bg-[#FF820F] bg-opacity-40 [backdrop-filter:blur(50px)]   box-border text-black"></div>
        </div>

        <div className="mx-[20px] max-lg:flex max-lg:justify-center max-lg:-center my-10 ">
          <div className="md:flex-row flex-col max-w-[1280px] mx-auto flex justify-center md:justify-between  ">
            <DomainTopic
              color={"bg-salmon-100"}
              img_path={"/domain1.png"}
              text="General English"
              path={"/courses/General_English"}
            />
            <DomainTopic
              color={"bg-orange-500"}
              img_path={"/domain2.png"}
              text="Domain Subjects"
              path={"/domain"}
            />
            <DomainTopic
              color={"bg-darkcyan"}
              img_path={"/domain3.png"}
              text="General Test"
              path={"/courses/General_Test"}
            />
          </div>
        </div>
      </div>
      <img
        src="/bubbles/bubble_og_01.png"
        alt=""
        className="absolute max-md:hidden right-0 z-0"
      />
    </section>
  );
};

export default SubjectTopic;